'use client'

import { useEffect } from 'react'

export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      return
    }

    if (process.env.NODE_ENV === 'development') {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister())
      })
      if ('caches' in window) {
        caches.keys().then((keys) => {
          keys.forEach((key) => caches.delete(key))
        })
      }
      return
    }

    // Register service worker
    const registerServiceWorker = async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/',
        })

        // Check for updates periodically
        setInterval(() => {
          registration.update()
        }, 60 * 60 * 1000) // Every hour

        // Handle updates
        // registration.addEventListener('updatefound', () => {
        //   const newWorker = registration.installing
        //   if (!newWorker) return

        //   newWorker.addEventListener('statechange', () => {
        //     if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
        //       if (window.confirm('새로운 버전이 있습니다. 업데이트하시겠습니까?')) {
        //         newWorker.postMessage({ type: 'SKIP_WAITING' })
        //         window.location.reload()
        //       }
        //     }
        //   })
        // })

        console.log('[SW] Service worker registered successfully')
      } catch (error) {
        console.error('[SW] Service worker registration failed:', error)
      }
    }

    // Wait for page load
    if (document.readyState === 'complete') {
      registerServiceWorker()
    } else {
      window.addEventListener('load', registerServiceWorker)
      return () => window.removeEventListener('load', registerServiceWorker)
    }
  }, [])

  return null
}
